var map = {
	"./svg/brandBountiesNetwork.svg": 780,
	"./svg/brandColony.svg": 781,
	"./svg/brandEthereum.svg": 782,
	"./svg/brandFirebase.svg": 783,
	"./svg/brandInfura.svg": 784,
	"./svg/brandMetaMask.svg": 785,
	"./svg/branduPort.svg": 786,
	"./svg/buidlbox.svg": 787,
	"./svg/socialDomain.svg": 788,
	"./svg/socialEmail.svg": 789,
	"./svg/socialFacebook.svg": 790,
	"./svg/socialGithub.svg": 791,
	"./svg/socialGoogle.svg": 792,
	"./svg/socialLinkedin.svg": 793,
	"./svg/socialPassport.svg": 794,
	"./svg/socialPhone.svg": 795,
	"./svg/socialReddit.svg": 796,
	"./svg/socialTwitter.svg": 797,
	"./svg/socialTwitterBird.svg": 798,
	"./svg/uportWhite.svg": 799,
	"./svg/waves.svg": 800
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 779;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.\/svg\/[^\/]+\.(svg)$
// module id = 779
// module chunks = 1 3